import type { Template } from "@/types";

export const PO_06_H1_V5: Template[] = [
    {
        id: "po-06-h1v5-01",
        name: "PO 01 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 67, y: 139, width: 462, height: 329, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 475, width: 149, height: 235, rotation: 0, imageRotation: 0 },
            { id: "3", x: 224, y: 475, width: 149, height: 235, rotation: 0, imageRotation: 0 },
            { id: "4", x: 381, y: 475, width: 148, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 651, y: 250, width: 238, height: 351, rotation: 0, imageRotation: 0 },
            { id: "6", x: 897, y: 250, width: 238, height: 351, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-02",
        name: "PO 02 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 123, y: 160, width: 350, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 638, y: 160, width: 163, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 638, y: 429, width: 163, height: 261, rotation: 0, imageRotation: 0 },
            { id: "4", x: 809, y: 429, width: 163, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 980, y: 429, width: 163, height: 261, rotation: 0, imageRotation: 0 },
            { id: "6", x: 809, y: 160, width: 334, height: 261, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "hs-06-h1v5-03",
        name: "HS 03 - H1V5",
        albumType: "HS",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 128, y: 166, width: 159, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 295, y: 166, width: 158, height: 264, rotation: 0, imageRotation: 0 },
            { id: "3", x: 128, y: 438, width: 324, height: 245, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 166, width: 325, height: 518, rotation: 0, imageRotation: 0 },         
            { id: "5", x: 975, y: 166, width: 160, height: 255, rotation: 0, imageRotation: 0 },
            { id: "6", x: 975, y: 429, width: 160, height: 255, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-04",
        name: "PO 04 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 71, y: 187, width: 453, height: 297, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 71, y: 492, width: 108, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 187, y: 492, width: 108, height: 171, rotation: 0, imageRotation: 0 },
            { id: "4", x: 303, y: 492, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 418, y: 492, width: 107, height: 171, rotation: 0, imageRotation: 0 },
            { id: "6", x: 742, y: 187, width: 300, height: 475, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h1v5-05",
        name: "PO 05 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_05.png",
        size: [1190, 850],
        style: {},
        slots: [        
            { id: "1", x: 49, y: 220, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 429, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 182, y: 220, width: 565, height: 410, rotation: 0, imageRotation: 0 },
            { id: "4", x: 755, y: 220, width: 251, height: 410, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1014, y: 220, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1014, y: 429, width: 125, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-06",
        name: "PO 06 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 44, y: 220, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 429, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 177, y: 220, width: 565, height: 410, rotation: 0, imageRotation: 0 },
            { id: "4", x: 887, y: 220, width: 259, height: 410, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 220, width: 129, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 750, y: 429, width: 129, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-07",
        name: "PO 07 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 49, y: 220, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 429, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 182, y: 220, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 182, y: 429, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 315, y: 221, width: 564, height: 410, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 221, width: 252, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-08",
        name: "PO 08 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 246, width: 199, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 207, y: 246, width: 199, height: 337, rotation: 0, imageRotation: 0 },
            { id: "3", x: 414, y: 246, width: 437, height: 337, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 246, width: 207, height: 337, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1074, y: 246, width: 114, height: 165, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1074, y: 419, width: 114, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-09",
        name: "PO 09 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 228, y: 144, width: 790, height: 563, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 144, width: 172, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 430, width: 172, height: 277, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1026, y: 144, width: 116, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1026, y: 335, width: 116, height: 182, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1026, y: 525, width: 116, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h1v5-10",
        name: "PO 10 - H1V5",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h1_v5_10.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 57, y: 169, width: 670, height: 512, rotation: 0, imageRotation: 0 },
            { id: "2", x: 734, y: 169, width: 196, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 938, y: 169, width: 195, height: 304, rotation: 0, imageRotation: 0 },
            { id: "4", x: 734, y: 480, width: 128, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 870, y: 480, width: 128, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 480, width: 128, height: 201, rotation: 0, imageRotation: 0 }
        ],
    }
];